import React, { useEffect } from "react";
import { styled } from "styled-components";
import { Call, Message, Share, Star } from "../../assets/icons";
import { Colors } from "../../ColorConstants";

const FeedbackShare = ({ email, phone, rating, totalRating, share }) => {
  let ratingPoint = Number(rating) * 20;
  return (
    <Feedback>
      {/* <Rating>
        <RateContainer>
          <RatePercentContainer width={ratingPoint}>
            <svg width="100" height="20">
              <clipPath id="maskRate">
                <path d="M10 1L13 7L19 7.75L14.88 12.37L16 19L10 16L4 19L5.13 12.37L1 7.75L7 7L10 1Z" />
                <path d="M30 1L33 7L39 7.75L34.88 12.37L36 19L30 16L24 19L25.13 12.37L21 7.75L27 7L30 1Z" />
                <path d="M70 1L73 7L79 7.75L74.88 12.37L76 19L70 16L64 19L65.13 12.37L61 7.75L67 7L70 1Z" />
                <path d="M90 1L93 7L99 7.75L94.88 12.37L96 19L90 16L84 19L85.13 12.37L81 7.75L87 7L90 1Z" />
                <path d="M50 1L53 7L59 7.75L54.88 12.37L56 19L50 16L44 19L45.13 12.37L41 7.75L47 7L50 1Z" />
              </clipPath>
            </svg>
          </RatePercentContainer>
        </RateContainer>
        <span>{totalRating} Review</span>
      </Rating> */}
      <SMShare>
        {email && (
          <a href={`mailto:${email}`} >
            <img src={Message} alt="Email" />
            {email && (
              <div style={{left: "200%"}} className="tooltip">
                {email}
              </div>
            )}
          </a>
        )}
        {phone && (
          <a href={`tel:${phone}`} >
            <img src={Call} alt="Call" />
            <div className="tooltip" style={{left: "150%"}}>{phone}</div>{" "}
          </a>
        )}
        {share && (
          <a href={`tel:${phone}`}>
            <img src={Share} alt="share" />
            <div className="tooltip">{phone}</div>{" "}
          </a>
        )}
      </SMShare>
    </Feedback>
  );
};

const RateContainer = styled.div`
  background: #c5c5c5;
  clip-path: ${"url(#maskRate)"};
`;

const RatePercentContainer = styled.div`
  background: #ffc700;
  clip-path: ${"url(#maskRate)"};
  width: ${(props) => props.width}%;
`;

const Feedback = styled.div`
  display: flex;
  justify-self: flex-start;
  margin-top: 0rem;
  // border: 1px solid red;
  @media only screen and (max-width: 1024px) {
    // margin-top: 1rem;
  }
`;
const SMShare = styled.div`
  display: flex;
  gap: 1rem;
  // align-items: center;
  margin-top: 0.8rem;
  // border: 1px solid red;
  justify-content: flex-end;
  position: relative;
  > a > img {
    width: 1.5rem;
    height: 1.5rem;
  }
  .tooltip {
    position: absolute;
    top: 100%;
    left: 100%;
    transform: translateX(-50%);
    background-color: rgba(0, 0, 0, 0.8);
    color: #fff;
    padding: 0.25rem 0.5rem;
    border-radius: 0.25rem;
    opacity: 0;
    transition: opacity 0.3s;
    white-space: nowrap;
    pointer-events: none;
    cursor: pointer;
    @media only screen and (max-width: 1024px) {
      top: -105%;
      transform: translateX(-150%);
    }
  }
  :hover .tooltip {
    opacity: 1;
  }
`;
const Rating = styled.div`
  width: 60%;
  display: flex;
  align-items: center;
  > span {
    color: ${Colors.darkGrey};
    font-size: 0.75rem;
    padding-left: 1rem;
    margin-left: 1rem;
    border-left: 1px solid ${Colors.chineeseSilver};
  }
`;

export default FeedbackShare;
